module.exports = __webpack_public_path__ + "img/PAB.b25b066e.png";